import styled from "styled-components"
import { FlexWrapper } from "components/ui/FlexWrapper/styles"

export const Wrapper = styled(FlexWrapper)`
  p {
    padding: 1.25rem 0 2.5rem;
  }
`
